import { render, staticRenderFns } from "./fireFightingTraningEdu.vue?vue&type=template&id=ad3cedc4"
import script from "./fireFightingTraningEdu.vue?vue&type=script&lang=js"
export * from "./fireFightingTraningEdu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad3cedc4')) {
      api.createRecord('ad3cedc4', component.options)
    } else {
      api.reload('ad3cedc4', component.options)
    }
    module.hot.accept("./fireFightingTraningEdu.vue?vue&type=template&id=ad3cedc4", function () {
      api.rerender('ad3cedc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/fte/fireFightingTraningEdu.vue"
export default component.exports